import {
  getFromServerToken,
  postToServerToken,
  deleteFromServerToken,
} from "./fetch";
import { useState, useContext } from "react";
import EventContext from "../store/event-context";

const useUnassigned = () => {
  const [isLoadingUnassigned, setIsLoading] = useState(false);
  const [unassignedData, setData] = useState([]);
  const [unassignedServerError, setServerError] = useState(null);
  const eventctx = useContext(EventContext);

  const getUnassigned = async (color) => {
    setIsLoading(true);

    const { data, status } = await getFromServerToken(`/events/${eventctx.eventId}/unassigned/` + color);
    //console.log("Data from getUnassigned:",data);

    if (status === 404) {
      setServerError(`No unassigned caps gevonden`);
    } else if (status === 204) {
      setServerError("lijst met caps is leeg");
    } else if (status >= 400) {
      setServerError(data.detail);
      setData([]);
    } else {
      setData(formatData(data.caps));
      setServerError("");
    }
    setIsLoading(false);
  };

  const removeUnassigned = async (color, capnr) => {
    setIsLoading(true);
    const { data, status } = await deleteFromServerToken(
      `/events/${eventctx.eventId}/unassigned/${color}/${capnr}`
    );

    //console.log("Data from removeUnassigned:",data);

    if (status === 404) {
      setServerError(`Capnr ${capnr} is niet gevonden`);
    } else if (status >= 400) {
      setServerError(data.detail);
      setData([]);
    } else {
      setData(formatData(data.caps));
      setServerError("");
    }
    setIsLoading(false);
    return data;
  };

  const addUnassigned = async (color, capnrs) => {
    setIsLoading(true);
    const { data, status } = await postToServerToken(
      `/events/${eventctx.eventId}/unassigned/${color}`,
      `{"ranges": "${capnrs}", "prefix": ""}`
    );

    //console.log("Data from addUnassigned:",data);

    if (status >= 400) {
      setServerError(data.detail);
      setData([]);
    } else {
      setData(formatData(data.caps));
      setServerError("");
    }
    setIsLoading(false);
    return data;
  };

  const formatData = (data) => {
    let tmpData = [];
    data.forEach((item, index) => {
      const capnr = item;
      const id = index;
      tmpData.push({capnr, id})
    });
    //console.log("Data after format: ", tmpData);
    return tmpData;
  }

  return {
    unassignedData,
    isLoadingUnassigned,
    unassignedServerError,
    getUnassigned,
    removeUnassigned,
    addUnassigned,
  };
};

export default useUnassigned;
